import Policy from "./Policy.presenter";
export default Policy;
